import styled from 'styled-components';
import { colors } from '../../../../globalStyles';
import { Styles } from '../../styles';
import { CategoryTone, SeverityTone } from './AssessmentFlags.types';

export const categoryToneStyles: Record<
  CategoryTone,
  { background: string; border: string; color: string }
> = {
  academic: {
    background: colors.warningBg,
    border: colors.warning,
    color: colors.warning,
  },
  basic: {
    background: colors.dangerBg,
    border: colors.dangerBgLogo,
    color: colors.danger,
  },
  career: {
    background: colors.primaryBg,
    border: colors.friendlyWarning,
    color: colors.primary,
  },
  default: {
    background: colors.greyBg,
    border: colors.grey.lightBorder,
    color: colors.secondary,
  },
  wellness: {
    background: colors.successBg,
    border: colors.success,
    color: colors.successDark,
  },
};

export const FlagsWidget = styled(Styles.widget)`
  padding: 18px 18px 20px;
  margin-bottom: 0;
  min-height: 260px;
  border: 1px solid ${colors.secondaryBorder};
  border-radius: 12px;
`;

export const FlagsHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 2px 16px;
`;

export const FlagsTitle = styled.h2`
  margin: 0;
  color: ${colors.text};
  font-size: 24px;
  font-weight: 400;
`;

export const ComplexNeedsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 16px;
  background-color: ${colors.dangerBgInternal};
  color: ${colors.white};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const FlagsTableDiv = styled.div`
  margin: 0 2px;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid ${colors.grey.lightBorder};
  border-radius: 12px;
`;

export const FlagsTable = styled.table`
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;

  th {
    padding: 15px 16px;
    color: ${colors.secondary};
    background-color: ${colors.greyBg};
    font-size: 14px;
    font-weight: 600;
  }

  th:first-child {
    width: 40%;
  }

  th:nth-child(2) {
    width: 18%;
  }

  th:nth-child(3) {
    width: 42%;
  }

  td {
    padding: 14px 16px;
    border-top: 1px solid ${colors.grey.lightBorder};
    color: ${colors.text};
    font-size: 15px;
    vertical-align: middle;
  }
`;

export const FlagNameTd = styled.td`
  font-weight: 700;
`;

export const SeverityTd = styled.td<{ $tone: SeverityTone }>`
  color: ${({ $tone }) =>
    $tone === 'severe'
      ? colors.danger
      : $tone === 'watch'
      ? colors.secondary
      : colors.brandAlt} !important;
  font-weight: 700;
`;

export const CategoryBadge = styled.span<{ $tone: CategoryTone }>`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  max-width: 100%;
  padding: 4px 10px;
  border: 1px solid ${({ $tone }) => categoryToneStyles[$tone].border};
  border-radius: 14px;
  background-color: ${({ $tone }) => categoryToneStyles[$tone].background};
  color: ${({ $tone }) => categoryToneStyles[$tone].color};
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
`;

export const EmptyStateDiv = styled.div`
  min-height: 42px;
  color: ${colors.grayText};
  font-size: 14px;
  line-height: 1.5;
`;
